import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../components/Axios";

export const fetchLogos = createAsyncThunk("logos/fetch", async (arg, thunkAPI) => {
  const response = await axios.get("/video_project/" + arg + "/logos");
  thunkAPI.dispatch({
    type: "logos/setItems",
    payload: { items: response.data, id: arg },
  });
  return response.data;
});

// handle actions in reducers
export const logos = createSlice({
  name: "logos",
  initialState: {
    loading: "idle",
    items: [],
    id: null,
  },
  reducers: {
    clear: (state, action) => {
      state.items = [];
      state.id = null;
      return state;
    },
    setItems: (state, action) => {
      //set data
      state.loading = "idle";
      state.items = action.payload.items;
      if ("id" in action.payload) state.id = action.payload.id;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLogos.pending, (state, action) => {
      state.loading = "pending";
      state.items = [];
    });
  },
});
